import { createTypes } from "../../utils/helpers";

const BRANDS_GET_ENTITIES: any = createTypes('BRANDS_GET_ENTITIES');

export {
    BRANDS_GET_ENTITIES,
}
